// src/services/api.js
// Base ORDS configurable por variable de entorno (Vue CLI: VUE_APP_*).
// Fallback a la URL productiva/demo para mantener retrocompatibilidad.
const API_BASE =
  process.env.VUE_APP_ORDS_BASE ||
  "https://g220992e7796ae2-db20220530220647.adb.mx-queretaro-1.oraclecloudapps.com/ords/crm_app/cxdemo";

export { API_BASE };

export async function apiGet(path) {
  const r = await fetch(API_BASE + path, {
    headers: { Accept: "application/json" },
  });
  if (!r.ok) throw new Error("GET " + path + " → " + r.status);
  return r.json();
}

export async function apiPost(path, body) {
  const r = await fetch(API_BASE + path, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body),
  });
  return r.json();
}

export async function apiPut(path, body) {
  const r = await fetch(API_BASE + path, {
    method: "PUT",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body),
  });
  // ORDS suele responder 200 con cuerpo JSON incluso en errores de negocio;
  // se devuelve el cuerpo y, si no es OK y no hay cuerpo útil, se anexa el status.
  let data = null;
  try {
    data = await r.json();
  } catch (e) {
    data = null;
  }
  if (!r.ok && (data == null || typeof data !== "object")) {
    throw new Error("PUT " + path + " → " + r.status);
  }
  return data ?? { ok: r.ok, status: r.status };
}

export async function apiDelete(path) {
  const r = await fetch(API_BASE + path, {
    method: "DELETE",
    headers: { Accept: "application/json" },
  });
  let data = null;
  try {
    data = await r.json();
  } catch (e) {
    data = null;
  }
  if (!r.ok && (data == null || typeof data !== "object")) {
    throw new Error("DELETE " + path + " → " + r.status);
  }
  return data ?? { ok: r.ok, status: r.status };
}
